"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const operators_1 = require("rxjs/operators");
const rxjs_1 = require("rxjs");
const resident_search_service_1 = require("./services/resident-search.service");
require("./dtos/resident-search-dto");
const i0 = require("@angular/core");
const i1 = require("./services/resident-search.service");
const i2 = require("../../directives/click-outside-directive");
const i3 = require("@angular/common");
const i4 = require("@angular/forms");
const i5 = require("../dnaR-spinner/dnaR-spinner.component");
const i6 = require("../../../residents/resident-profile-photo/resident-profile-photo.component");
function DnaRSearch_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵelementStart(2, "a", 8);
    i0.ɵɵlistener("click", function DnaRSearch_span_4_Template_a_click_2_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); $event.stopPropagation(); return ctx_r3.onClearSelectedItem(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function DnaRSearch_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r1.requiredError, " ");
} }
function DnaRSearch_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵelementStart(2, "li", 12);
    i0.ɵɵelement(3, "dnaR-spinner", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function DnaRSearch_div_6_div_2_li_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "uppercase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", item_r9.firstName, " ", i0.ɵɵpipeBind1(2, 2, item_r9.lastName), " ");
} }
function DnaRSearch_div_6_div_2_li_2_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "uppercase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate3(" ", item_r9.firstName, " ", i0.ɵɵpipeBind1(2, 3, item_r9.lastName), " (", item_r9.preferredName, ") ");
} }
function DnaRSearch_div_6_div_2_li_2_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, item_r9.dateOfBirth, "dd-MMM-yyyy"));
} }
function DnaRSearch_div_6_div_2_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 15);
    i0.ɵɵlistener("click", function DnaRSearch_div_6_div_2_li_2_Template_li_click_0_listener($event) { i0.ɵɵrestoreView(_r17); const item_r9 = ctx.$implicit; const ctx_r16 = i0.ɵɵnextContext(3); $event.stopPropagation(); return ctx_r16.onItemClick(item_r9); });
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵelement(2, "resident-profile-photo", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 18);
    i0.ɵɵtemplate(4, DnaRSearch_div_6_div_2_li_2_div_4_Template, 3, 4, "div", 19);
    i0.ɵɵtemplate(5, DnaRSearch_div_6_div_2_li_2_div_5_Template, 3, 5, "div", 19);
    i0.ɵɵtemplate(6, DnaRSearch_div_6_div_2_li_2_div_6_Template, 3, 4, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("residentId", item_r9.id);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !item_r9.preferredName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r9.preferredName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r9.dateOfBirth);
} }
function DnaRSearch_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵtemplate(2, DnaRSearch_div_6_div_2_li_2_Template, 7, 4, "li", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r6.results);
} }
function DnaRSearch_div_6_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵelementStart(2, "li");
    i0.ɵɵelementStart(3, "div", 23);
    i0.ɵɵtext(4, "No results");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function DnaRSearch_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, DnaRSearch_div_6_div_1_Template, 4, 0, "div", 10);
    i0.ɵɵtemplate(2, DnaRSearch_div_6_div_2_Template, 3, 1, "div", 10);
    i0.ɵɵtemplate(3, DnaRSearch_div_6_div_3_Template, 5, 0, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.results);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.results && ctx_r2.results.length <= ctx_r2.maxResults);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.results && ctx_r2.results.length == 0);
} }
const _c0 = function (a0) { return { "warning-box": a0 }; };
class DnaRSearch {
    constructor(residentSearchService) {
        this.residentSearchService = residentSearchService;
        this.showError = false;
        this.itemSelected = false;
        this.placeholder = 'Search';
        this.showClearSelectedItems = true;
        this.validate = false;
        /* Maximum number of results to be displayed.
         * If more results are found then no results will be shown until less matches are returned */
        this.maxResults = 10;
        this.isRequired = false;
        this.requiredError = 'Input value is required.';
        this.name = '';
        this.value = '';
        this.valueChange = new core_1.EventEmitter();
        this.onTouchedEvent = new core_1.EventEmitter();
        this.onDropDownClose = new core_1.EventEmitter();
        this.onTouchedCallback = () => { this.onTouchedEvent.emit(true); };
        this.results = undefined;
        this.changedInput = new rxjs_1.Subject();
    }
    ngOnInit() {
        this.changedInput
            .pipe(operators_1.debounceTime(500), operators_1.distinctUntilChanged()).subscribe((value) => __awaiter(this, void 0, void 0, function* () {
            this.value = value;
            this.searchValue = value;
            this.itemSelected = false;
            if (value.length > 1) {
                this.showError = false;
                this.results = yield this.residentSearchService.getResidents(value.toLowerCase());
                if (this.results.length == 0) {
                    this.value = '';
                }
            }
        }));
    }
    ngOnChanges() {
        this.showError = this.validate && (!this.value || this.value.length < 2) && !this.itemSelected;
    }
    onItemClick(item) {
        this.value = item.firstName + ' ' + item.lastName.toUpperCase();
        this.valueChange.emit(item);
        this.searchValue = '';
        this.itemSelected = true;
    }
    toggleDropdown(evt) {
        if (!this.itemSelected) {
            this.onTouchedCallback();
            this.onDropDownClose.emit();
            this.showHideDropdowns(evt);
            this.onClearSelectedItem();
        }
    }
    showHideDropdowns(evt) {
        // Get all dropdowns
        const dropdowns = document.getElementsByClassName('dropdown-list');
        // Hide all dropdowns
        Array.from(dropdowns).map(x => x.classList.add('hide'));
        // Get the parent's children
        if (evt.currentTarget.parentElement) {
            const children = Array.from(evt.currentTarget.parentElement.parentElement.children);
            // Show current target dropdown
            children.forEach((child) => {
                if (child['classList'].contains('dropdown-list')) {
                    child['classList'].remove('hide');
                }
            });
        }
    }
    onClearSelectedItem() {
        this.onTouchedCallback();
        this.results = undefined;
        this.value = '';
        this.itemSelected = false;
        //Emit an empty string to allow searching for the same value that was previously searched:
        this.changedInput.next(this.value);
        //Clear selected value used elsewhere:
        this.valueChange.emit(null);
    }
}
exports.DnaRSearch = DnaRSearch;
DnaRSearch.ɵfac = function DnaRSearch_Factory(t) { return new (t || DnaRSearch)(i0.ɵɵdirectiveInject(i1.ResidentSearchService)); };
DnaRSearch.ɵcmp = i0.ɵɵdefineComponent({ type: DnaRSearch, selectors: [["dnaR-search"]], inputs: { placeholder: "placeholder", showClearSelectedItems: "showClearSelectedItems", validate: "validate", maxResults: "maxResults", isRequired: "isRequired", requiredError: "requiredError", name: "name", value: "value" }, outputs: { valueChange: "valueChange", onTouchedEvent: "onTouchedEvent", onDropDownClose: "onDropDownClose" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 11, consts: [["tabindex", "=0", 1, "search", 3, "clickOutside"], [1, "dnaRComponent", "dnaRInput", 3, "ngClass"], [1, "search-icon"], ["type", "text", 3, "name", "ngModel", "placeholder", "required", "size", "ngModelChange"], ["class", "selected-items-clear", 4, "ngIf"], ["class", "helper-text", 4, "ngIf"], [4, "ngIf"], [1, "selected-items-clear"], [3, "click"], [1, "helper-text"], ["class", "results-list", 4, "ngIf"], [1, "results-list"], [1, "spinner"], ["data-automation", "spinner"], ["class", "search-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "search-item", 3, "click"], [1, "photo-wrapper"], [3, "residentId"], [1, "resident-details"], ["class", "itemText", 4, "ngIf"], ["class", "dob", 4, "ngIf"], [1, "itemText"], [1, "dob"], [1, "no-results"]], template: function DnaRSearch_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("clickOutside", function DnaRSearch_Template_div_clickOutside_0_listener($event) { $event.stopPropagation(); return ctx.toggleDropdown($event); });
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "span", 2);
        i0.ɵɵelementStart(3, "input", 3);
        i0.ɵɵlistener("ngModelChange", function DnaRSearch_Template_input_ngModelChange_3_listener($event) { return ctx.value = $event; })("ngModelChange", function DnaRSearch_Template_input_ngModelChange_3_listener($event) { return ctx.changedInput.next($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, DnaRSearch_span_4_Template, 3, 0, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, DnaRSearch_p_5_Template, 2, 1, "p", 5);
        i0.ɵɵtemplate(6, DnaRSearch_div_6_Template, 4, 3, "div", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0, ctx.isRequired && ctx.requiredError && ctx.showError));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", ctx.name)("ngModel", ctx.value)("placeholder", ctx.placeholder)("required", ctx.isRequired)("size", ctx.maxResults);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.searchValue && ctx.searchValue.length !== 0 || ctx.value) && ctx.showClearSelectedItems);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isRequired && ctx.requiredError && ctx.showError);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.searchValue && ctx.searchValue.length > 1);
    } }, directives: [i2.ClickOutsideDirective, i3.NgClass, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, i4.RequiredValidator, i3.NgIf, i5.DnaRSpinner, i3.NgForOf, i6.ResidentProfilePhotoComponent], pipes: [i3.UpperCasePipe, i3.DatePipe], styles: ["input[_ngcontent-%COMP%]:focus {\n  outline: none !important;\n}\n.dnaRComponent[_ngcontent-%COMP%] {\n  display: flex;\n  justify-content: space-between;\n  border: 1px solid #AAAAAA;\n  border-radius: 2px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0;\n}\n.dnaRComponent[_ngcontent-%COMP%]:hover {\n  border-color: #000000;\n}\n.dnaRComponent[_ngcontent-%COMP%]:focus-within {\n  border-color: #008381;\n}\n.valid[_ngcontent-%COMP%] {\n  border-color: #AAAAAA;\n}\n.invalid[_ngcontent-%COMP%] {\n  border-color: #C53535 !important;\n}\n.dnaRInputContainer[_ngcontent-%COMP%] {\n  display: inline-block;\n}\n.dnaRInput[_ngcontent-%COMP%]   input[_ngcontent-%COMP%] {\n  padding: 5px;\n  height: 32px;\n  outline: none;\n  border: 0;\n  color: #414141;\n  width: 100%;\n}\n.dnaRInput[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder {\n  \n  color: #757575;\n  opacity: 1;\n  \n}\n.dnaRInput[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:-ms-input-placeholder {\n  \n  color: #757575;\n}\n.dnaRInput[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-ms-input-placeholder {\n  \n  color: #757575;\n}\n.dnaRInput[_ngcontent-%COMP%]   .prefix[_ngcontent-%COMP%] {\n  padding: 0 5px;\n  line-height: 32px;\n}\n.dnaRInput[_ngcontent-%COMP%]   .postfix[_ngcontent-%COMP%] {\n  padding: 0 5px;\n  line-height: 32px;\n}\n.dnaRInput.disabled[_ngcontent-%COMP%] {\n  border-color: #D2D2D2;\n  background-color: #F5F5F5;\n  color: #757575;\n}\n.toRight[_ngcontent-%COMP%] {\n  text-align: right;\n}\n.error[_ngcontent-%COMP%] {\n  color: #C53535;\n  float: left;\n  font-size: 12px;\n  padding-bottom: 5px;\n}\n.dnaRComponent[_ngcontent-%COMP%]   input.ng-touched.ng-invalid[_ngcontent-%COMP%]:focus, .ng-submitted[_ngcontent-%COMP%]   .ng-invalid[_ngcontent-%COMP%]:focus {\n  box-shadow: none !important;\n}\n.dnaRInput[_ngcontent-%COMP%] {\n  background-color: #ffffff;\n  color: #757575;\n}\n.search-icon[_ngcontent-%COMP%] {\n  flex: auto;\n  width: 24px;\n  height: 24px;\n  margin-top: 4px;\n  margin-left: 5px;\n  background-image: url(images/search-fill.svg);\n  background-repeat: no-repeat;\n  background-position: center;\n  cursor: default;\n}\n.results-list[_ngcontent-%COMP%]:not(.hide) {\n  position: absolute;\n  top: 34px;\n  padding: 4px 0;\n  width: 100%;\n  z-index: 9999;\n  border: 1px solid #ccc;\n  background: #fff;\n  box-shadow: 0px 1px 5px #959595;\n  max-height: 385px;\n  overflow: auto;\n}\n.results-list[_ngcontent-%COMP%]:not(.hide)   ul[_ngcontent-%COMP%] {\n  padding: 0px;\n  list-style: none;\n  overflow: auto;\n  margin: 0px;\n}\n.results-list[_ngcontent-%COMP%]:not(.hide)   li[_ngcontent-%COMP%] {\n  padding: 8px 16px;\n  cursor: pointer;\n  text-align: left;\n  line-height: 24px;\n}\n.results-list[_ngcontent-%COMP%]:not(.hide)   .item-header[_ngcontent-%COMP%] {\n  font-weight: 600;\n}\n.search[_ngcontent-%COMP%] {\n  position: relative;\n  width: 100%;\n  height: 34px;\n  font-size: 16px;\n  font-family: inherit;\n}\n.search[_ngcontent-%COMP%]   .selected-items-clear[_ngcontent-%COMP%] {\n  width: 27px;\n  padding-top: 6px;\n}\n.search[_ngcontent-%COMP%]   .selected-items-clear[_ngcontent-%COMP%]   a[_ngcontent-%COMP%] {\n  display: inline-block;\n  padding-left: 5px;\n  line-height: 18px;\n  height: 19px;\n  width: 19px;\n  color: #fff;\n  border-radius: 50%;\n  text-decoration: none;\n  width: 20px;\n  height: 20px;\n  background-image: url(\"images/cancel-fill.svg\");\n  background-repeat: no-repeat;\n  background-position: center;\n}\nli.search-item[_ngcontent-%COMP%] {\n  min-height: 64px;\n  display: flex;\n}\nli.search-item[_ngcontent-%COMP%]   .itemText[_ngcontent-%COMP%] {\n  margin-top: 3px;\n  display: flex;\n  flex-direction: column;\n}\nli.search-item[_ngcontent-%COMP%]   .dob[_ngcontent-%COMP%] {\n  display: flex;\n  flex-direction: column;\n  font-size: 12px;\n}\n.no-results[_ngcontent-%COMP%] {\n  display: flex;\n  text-align: center;\n  height: 30px;\n  line-height: 30px;\n  cursor: default;\n}\nli.search-item[_ngcontent-%COMP%]:hover {\n  background: #008381;\n  text-decoration: none;\n  color: white !important;\n}\n.search[_ngcontent-%COMP%]     .mat-progress-spinner circle, .mat-spinner[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%] {\n  display: flex;\n  stroke: #008381 !important;\n  height: 24px !important;\n  width: 24px !important;\n  background-color: white;\n}\n.spinner[_ngcontent-%COMP%] {\n  display: flex;\n  justify-content: center;\n}\n.photo-wrapper[_ngcontent-%COMP%] {\n  box-sizing: border-box;\n  width: 32px !important;\n  height: 32px;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  margin-right: 16px;\n}\n.helper-text[_ngcontent-%COMP%] {\n  font-size: 12px;\n  color: #C53535;\n  padding-left: 2px;\n  padding-top: 4px;\n}\n.warning-box[_ngcontent-%COMP%] {\n  border-color: #C53535;\n}\n.warning-box[_ngcontent-%COMP%]:hover, .warning-boxfocus[_ngcontent-%COMP%] {\n  border-color: #C53535;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DnaRSearch, [{
        type: core_1.Component,
        args: [{
                selector: 'dnaR-search',
                templateUrl: './dnaR-search.component.html',
                styleUrls: ['./dnaR-search.component.less'],
            }]
    }], function () { return [{ type: i1.ResidentSearchService }]; }, { placeholder: [{
            type: core_1.Input
        }], showClearSelectedItems: [{
            type: core_1.Input
        }], validate: [{
            type: core_1.Input
        }], maxResults: [{
            type: core_1.Input
        }], isRequired: [{
            type: core_1.Input
        }], requiredError: [{
            type: core_1.Input
        }], name: [{
            type: core_1.Input
        }], value: [{
            type: core_1.Input
        }], valueChange: [{
            type: core_1.Output
        }], onTouchedEvent: [{
            type: core_1.Output
        }], onDropDownClose: [{
            type: core_1.Output
        }] }); })();
